@if (client?.civilId && client?.id) {
  <div class="top-padding-16">
    <h3 class="edit-screen-card-title">
      {{ 'identityReports.ccrReport' | translate }}
    </h3>
    <div
      flex
      layout="row"
      layout-wrap
      layout-align="space-between stretch"
      >
      <div flex="100" flex-gt-md="75" flex-gt-sm="100" flex-gt-xs="100">
        <itfg-reports-info-panel
          [listData]="ccrListData"
          [reportData]="ccrReportData"
          [reportTime]="reportTime"
          [requesterName]="ccrReportData?.requesterName"
          [metaStatusCode]="metaStatusCode"
          [requestTime]="ccrTime"
          (dataChanged)="ccrDataChanged($event)"
        ></itfg-reports-info-panel>
      </div>
      <div flex layout="row" layout-align="end start" [style.min-height.px]="65">
        <itfg-client-differences-button
          [config]="ccrConfig"
          >
        </itfg-client-differences-button>
        <button
          mat-icon-button
          [disabled]="['CCR_ADD'] | isUnauthorized | async"
          matTooltip="{{ 'ccrRequests.uploadReport' | translate }}"
          (click)="uploadCcrRequestsReport()"
          >
          <mat-icon>upload</mat-icon>
        </button>
        <button
          mat-raised-button
          [disabled]="['CCR_ADD'] | isUnauthorized | async"
          (click)="getNewCcr()"
          >
          {{ 'ccr.newCcr' | translate }}
        </button>
      </div>
    </div>
    <!-- <itfg-ccr-report-summary
    *ngIf= "ccrReportData?.status === 'success' &&
    !!ccrData &&
    ccrData?.borrower?.section?.length > 0 &&
    ccrReportData?.type === 'ccr'"
    [reportData]="ccrReportData"
    >
  </itfg-ccr-report-summary> -->
  <!-- CCR requests report -->
  @if (ccrReportData?.type === 'ccr_requests') {
    <mat-card appearance="outlined">
      <itfg-ccr-requests
        [report]="ccrReportData?.data">
      </itfg-ccr-requests>
    </mat-card>
  }
  @if (ccrListData?.length === 0 && client?.id) {
    <h4
      flex
      layout="row"
      layout-align="start center"
      >
      {{ 'credits.noCcrFiles' | translate: { civilId: client?.civilId } }}
    </h4>
  }
  @if (
    (
    ccrListData?.length > 0 &&
    client?.id &&
    ccrData?.borrower?.code &&
    ccrData?.borrower?.section?.length === 0 &&
    client?.civilId
    )
    ) {
    <h4
      flex
      layout="row"
      layout-align="start center"
      >
      {{ 'credits.noCcrData' | translate: { civilId: client?.civilId } }}
    </h4>
  }
  @if (
    (
    ccrListData?.length > 0 &&
    client?.id  &&
    client?.civilId && ccrReportData?.status === 'no_data'
    )
    ) {
    <h4
      flex
      layout="row"
      layout-align="start center"
      >
      {{ 'credits.noCcrInfo' | translate: { civilId: client?.civilId, ccrTime: ccrTime | itfgDateFormat, source: ccrReportData?.source || '-'} }}
      <itfg-no-reports-info
        [alertMessage]="{civilId: client?.civilId, type: ccrReportData?.type, source: ccrReportData?.source, status: ccrReportData?.status, time: ccrReportData?.time, data: ccrReportData?.data}">
      </itfg-no-reports-info>
    </h4>
  }
  @switch (ccrReportData?.status) {
    @case ('server_error') {
      <h4 layout="row" layout-align="start center">
        {{ 'reports.serverGenericError' | translate: {requestTime: ccrTime | itfgDateFormat} }}
        <itfg-no-reports-info
          [alertMessage]="{civilId: client?.civilId, type: ccrReportData?.type, source: ccrReportData?.source, status: ccrReportData?.status, time: ccrReportData?.time, data: ccrReportData?.data}">
        </itfg-no-reports-info>
      </h4>
    }
    @case ('server_timeout') {
      <h4 layout="row" layout-align="start center">
        {{ 'reports.serverTimeoutError' | translate: {requestTime: ccrTime | itfgDateFormat} }}
        <itfg-no-reports-info
          [alertMessage]="{civilId: client?.civilId, type: ccrReportData?.type, source: ccrReportData?.source, status: ccrReportData?.status, time: ccrReportData?.time, data: ccrReportData?.data}">
        </itfg-no-reports-info>
      </h4>
    }
  }
  @if (!client?.civilId && client?.id) {
    <h4
      [translate]="'credits.noCivilId'"
      flex
      layout="row"
      layout-align="start center"
      >
      The Client doest have civil id!
    </h4>
  }
</div>
}
@if (ccrData?.borrower?.section?.length > 0 && ccrReportData?.type === 'ccr') {
  @if (ccrData?.borrower?.section?.length > 0) {
    <h3
      class="edit-screen-card-title left-margin-25px"
      flex
      layout="row"
      layout-padding="10"
      layout-align="left"
      >
      @if (ccrData?.borrower?.section) {
        <span>{{
          'ccr.' + (ccrData?.borrower?.section)[0].entityType | translate
        }}</span>
      }
    </h3>
  }
  @if (
    ccrData?.borrower?.section &&
    (ccrData?.borrower?.section)[0].activeCredits
    ) {
    <div>
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title class="edit-screen-card-title">1. {{ 'ccr.active' | translate }}</mat-card-title>
            <mat-card-subtitle>
              <p class="active-count">
                {{
                'ccr.ccrActiveCountTemplate'
                | translate
                : {
                creditsCount:
                (ccrData?.borrower?.section)[0].activeCredits
                ?.credCount,
                sourcesCount:
                (ccrData?.borrower?.section)[0].activeCredits
                .sourceEntityCount
              }
              }}
            </p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          @if (
            (ccrData?.borrower?.section)[0].activeCredits?.summaries
            ?.length === 0
            ) {
            <span
              flex
              layout="row"
              class="left-margin-25px"
              [translate]="'global.noData'"
              >
              No Data</span
              >
            }
            @if (
              (ccrData?.borrower?.section)[0].activeCredits?.summaries?.length >
              0
              ) {
              <div
                >
                @for (
                  group of (ccrData?.borrower?.section)[0].activeCredits
                  .summaries
                  ; track
                  group) {
                  <div
                    >
                    <div
                      class="edit-screen-card-title left-padding-16 top-padding-16"
                      >
                      {{
                      group.groupingAttribute
                      | summaryGroupToTranslation
                      | translate
                      }}
                    </div>
                    @if (group?.summary) {
                      <itfg-data-table
                        [data]="group.summary"
                        [columns]="columnsActive"
                        >
                        <ng-template itfgDataTableTemplate="dateFrom" let-value="value">
                          <span>{{ value | date }}</span>
                        </ng-template>
                        <ng-template itfgDataTableTemplate="type" let-row="row">
                          <span>{{
                            row['type'] ||
                            row['overduePaymentPeriod'] ||
                            row['rest'] ||
                            row['term']
                          }}</span>
                        </ng-template>
                      </itfg-data-table>
                    }
                  </div>
                }
              </div>
            }
          </mat-card-content>
        </mat-card>
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title class="edit-screen-card-title"
              >2. {{ 'ccr.overdue' | translate }}</mat-card-title
              >
            </mat-card-header>
            <mat-card-content>
              @if (
                (ccrData?.borrower?.section)[0].overdueHistory?.summary
                ?.length === 0
                ) {
                <span
                  flex
                  layout="row"
                  class="left-margin-25px"
                  [translate]="'global.noData'"
                  >
                  No Data</span
                  >
                }
                @if (
                  (ccrData?.borrower?.section)[0].overdueHistory?.summary?.length >
                  0
                  ) {
                  <itfg-data-table
                    [data]="(ccrData?.borrower?.section)[0].overdueHistory.summary"
                    [columns]="columnsOverdue"
                    >
                    <ng-template itfgDataTableTemplate="active" let-value="value">
                      <span>{{
                        (value ? 'ccr.stateActive' : 'ccr.stateRefund') | translate
                      }}</span>
                    </ng-template>
                  </itfg-data-table>
                }
              </mat-card-content>
            </mat-card>
            <mat-card appearance="outlined">
              <mat-card-header>
                <mat-card-title class="edit-screen-card-title"
                  >3. {{ 'ccr.new' | translate }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                @if (
                  (ccrData?.borrower?.section)[0].newCredits?.summary.length === 0
                  ) {
                  <span
                    flex
                    layout="row"
                    class="left-margin-25px"
                    [translate]="'global.noData'"
                    >
                    No data</span
                    >
                  }
                  @if (
                    (ccrData?.borrower?.section)[0].newCredits?.summary?.length > 0
                    ) {
                    <itfg-data-table
                      [data]="(ccrData.borrower?.section)[0].newCredits.summary"
                      [columns]="columnsNew"
                      >
                    </itfg-data-table>
                  }
                </mat-card-content>
              </mat-card>
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title class="edit-screen-card-title"
                    >4. {{ 'ccr.relatedCredits' | translate }}
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  @if (
                    !((ccrData?.borrower?.section)[0]?.relatedActiveCredits
                    ?.creditsSet)[0]?.credCount &&
                    !((ccrData?.borrower?.section)[0]?.relatedActiveCredits
                    ?.creditsSet)[1]?.credCount
                    ) {
                    <span
                      flex
                      layout="row"
                      class="left-margin-25px"
                      [translate]="'global.noData'"
                      >
                      No data</span
                      >
                    }
                    @if (
                      (ccrData?.borrower?.section)[0].relatedActiveCredits?.creditsSet
                      ?.length > 0
                      ) {
                      <div
                        >
                        @for (
                          creditSet of (ccrData?.borrower?.section)[0]
                          ?.relatedActiveCredits?.creditsSet
                          ; track
                          creditSet) {
                          <div
                            >
                            @if (creditSet?.summary) {
                              <div
                                class="edit-screen-card-title left-padding-16 top-padding-16"
                                >
                                {{ creditSet.personRole }}
                              </div>
                            }
                            @if (creditSet?.summary) {
                              <p
                                class="active-count  left-padding-16"
                                >
                                {{
                                'ccr.ccrActiveCountTemplate'
                                | translate
                                : {
                                creditsCount: creditSet?.credCount,
                                sourcesCount: creditSet.sourceEntityCount
                              }
                              }}
                            </p>
                          }
                          @if (creditSet?.summary) {
                            <itfg-data-table
                              [data]="creditSet.summary"
                              [columns]="columnsRelated"
                              >
                              <ng-template itfgDataTableTemplate="dateFrom" let-value="value">
                                <span>{{ value | date }}</span>
                              </ng-template>
                            </itfg-data-table>
                          }
                        </div>
                      }
                    </div>
                  }
                </mat-card-content>
              </mat-card>
            </div>
          }
          @if (ccrData?.borrower?.section && (ccrData?.borrower?.section)[1]) {
            <h5
              class="edit-screen-card-title left-margin-25px"
              layout-padding="10"
              flex
              layout="row"
              layout-align="left"
              >
              <span>{{
                'ccr.' + (ccrData?.borrower?.section)[1].entityType | translate
              }}</span>
            </h5>
          }
          @if (ccrData?.borrower?.section && (ccrData?.borrower?.section)[1]) {
            <div>
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-card-title class="edit-screen-card-title"
                    >1. {{ 'ccr.active' | translate
                    }}@if ((ccrData?.borrower?.section)[1]) {
                    <span></span
                      >
                    }</mat-card-title>
                    <mat-card-subtitle>
                      <p class="active-count">
                        {{
                        'ccr.ccrActiveCountTemplate'
                        | translate
                        : {
                        creditsCount:
                        (ccrData?.borrower?.section)[1].activeCredits
                        ?.credCount,
                        sourcesCount:
                        (ccrData?.borrower?.section)[1].activeCredits
                        .sourceEntityCount
                      }
                      }}
                    </p>
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  @if (
                    (ccrData?.borrower?.section)[1].activeCredits?.summaries
                    ?.length === 0
                    ) {
                    <span
                      flex
                      layout="row"
                      class="left-margin-25px"
                      [translate]="'global.noData'"
                      >
                      No Data</span
                      >
                    }
                    @if (
                      (ccrData?.borrower?.section)[1].activeCredits.summaries.length > 0
                      ) {
                      <div
                        >
                        @for (
                          group of (ccrData?.borrower?.section)[1].activeCredits
                          .summaries
                          ; track
                          group) {
                          <div
                            >
                            <div
                              class="edit-screen-card-title left-padding-16 top-padding-16"
                              >
                              {{
                              group.groupingAttribute
                              | summaryGroupToTranslation
                              | translate
                              }}
                            </div>
                            <itfg-data-table [data]="group.summary" [columns]="columnsActive">
                              <ng-template itfgDataTableTemplate="dateFrom" let-value="value">
                                <span>{{ value | date }}</span>
                              </ng-template>
                              <ng-template itfgDataTableTemplate="type" let-row="row">
                                <span>{{
                                  row['type'] ||
                                  row['overduePaymentPeriod'] ||
                                  row['rest'] ||
                                  row['term']
                                }}</span>
                              </ng-template>
                            </itfg-data-table>
                          </div>
                        }
                      </div>
                    }
                  </mat-card-content>
                </mat-card>
                <mat-card appearance="outlined">
                  <mat-card-header>
                    <mat-card-title class="edit-screen-card-title"
                      >2. {{ 'ccr.overdue' | translate
                      }}@if ((ccrData?.borrower?.section)[1]) {
                      <span></span
                        >
                      }</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      @if (
                        (ccrData?.borrower?.section)[1].overdueHistory?.summary
                        ?.length === 0
                        ) {
                        <span
                          flex
                          layout="row"
                          class="left-margin-25px"
                          [translate]="'global.noData'"
                          >
                          No Data</span
                          >
                        }
                        @if (
                          (ccrData?.borrower?.section)[1].overdueHistory?.summary?.length >
                          0
                          ) {
                          <itfg-data-table
                            [data]="(ccrData?.borrower?.section)[1].overdueHistory?.summary"
                            [columns]="columnsOverdue"
                            >
                            <ng-template itfgDataTableTemplate="active" let-value="value">
                              <span>{{
                                (value ? 'ccr.stateActive' : 'ccr.stateRefund') | translate
                              }}</span>
                            </ng-template>
                          </itfg-data-table>
                        }
                      </mat-card-content>
                    </mat-card>
                    <mat-card appearance="outlined">
                      <mat-card-header>
                        <mat-card-title class="edit-screen-card-title"
                          >3. {{ 'ccr.new' | translate
                          }}@if ((ccrData?.borrower?.section)[1]) {
                          <span></span
                            >
                          }</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                          @if (
                            (ccrData?.borrower?.section)[1].newCredits.summary?.length === 0
                            ) {
                            <span
                              flex
                              layout="row"
                              class="left-margin-25px"
                              [translate]="'global.noData'"
                              >
                              No Data</span
                              >
                            }
                            @if (
                              (ccrData?.borrower?.section)[1].newCredits?.summary?.length > 0
                              ) {
                              <itfg-data-table
                                [data]="(ccrData?.borrower?.section)[1].newCredits?.summary"
                                [columns]="columnsNew"
                                >
                              </itfg-data-table>
                            }
                          </mat-card-content>
                        </mat-card>
                        <mat-card appearance="outlined">
                          <mat-card-header>
                            <mat-card-title class="edit-screen-card-title"
                              >4. {{ 'ccr.relatedCredits' | translate }}
                            </mat-card-title>
                          </mat-card-header>
                          <mat-card-content>
                            @if (
                              !((ccrData?.borrower?.section)[1]?.relatedActiveCredits
                              ?.creditsSet)[0]?.credCount &&
                              !((ccrData?.borrower?.section)[1]?.relatedActiveCredits
                              ?.creditsSet)[1]?.credCount
                              ) {
                              <span
                                flex
                                layout="row"
                                class="left-margin-25px"
                                [translate]="'global.noData'"
                                >
                                No data</span
                                >
                              }
                              @if (
                                (ccrData?.borrower?.section)[1]?.relatedActiveCredits?.creditsSet
                                ?.length > 0
                                ) {
                                <div
                                  >
                                  @for (
                                    creditSet of (ccrData?.borrower?.section)[1]
                                    ?.relatedActiveCredits?.creditsSet
                                    ; track
                                    creditSet) {
                                    <div
                                      >
                                      @if (creditSet?.summary) {
                                        <div
                                          class="edit-screen-card-title left-padding-16 top-padding-16"
                                          >
                                          {{ creditSet.personRole }}
                                        </div>
                                      }
                                      @if (creditSet?.summary) {
                                        <p
                                          class="active-count  left-padding-16"
                                          >
                                          {{
                                          'ccr.ccrActiveCountTemplate'
                                          | translate
                                          : {
                                          creditsCount: creditSet?.credCount,
                                          sourcesCount: creditSet.sourceEntityCount
                                        }
                                        }}
                                      </p>
                                    }
                                    @if (creditSet?.summary) {
                                      <itfg-data-table
                                        [data]="creditSet.summary"
                                        [columns]="columnsRelated"
                                        >
                                        <ng-template itfgDataTableTemplate="dateFrom" let-value="value">
                                          <span>{{ value | date }}</span>
                                        </ng-template>
                                      </itfg-data-table>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </mat-card-content>
                        </mat-card>
                      </div>
                    }
                  }
@if (ccrReportData?.type === 'ecr') {
  <mat-expansion-panel hideToggle>
  <mat-expansion-panel-header>
    <mat-panel-title> Debug </mat-panel-title>
  </mat-expansion-panel-header>
  <itfg-ccr-report-summary
    *ngIf= "ccrReportData?.status === 'success'"
    [reportData]="ccrReportData"
    >
  </itfg-ccr-report-summary>
</mat-expansion-panel>


  <h5
    class="edit-screen-card-title left-margin-25px"
    layout-padding="10"
    flex
    layout="row"
    layout-align="left">
    <span>{{'ccr.banks' | translate}}</span>
  </h5>
  @if (!!ccrData?.banksData) {
    <itfg-ecr-data-section 
      [sectionData]="ccrData.banksData"
      [columnsActive]="columnsActiveEcr"
      [columnsRelatedEcr]="columnsRelatedEcr"
      [columnsActiveMultiproducts]="columnsActiveMultiproducts"
      [columnsOverdue]="columnsOverdueEcr"
      [columnsDelinquencyHistoryEcr]="columnsDelinquencyHistoryEcr"
      [columnsLegacyDelinquencyHistoryEcr]="columnsLegacyDelinquencyHistoryEcr"
      [columnsInquiryEcr]="columnsInquiryEcr">
    </itfg-ecr-data-section>
  } @else {
    <mat-card>
      <mat-card-content>
        <span flex
              layout="row"
              class="no-data-label"
              [translate]="'global.noData'">
          No Data
        </span>
      </mat-card-content>
    </mat-card>
  }

  <h5
    class="edit-screen-card-title left-margin-25px"
    layout-padding="10"
    flex
    layout="row"
    layout-align="left">
    <span>{{'ccr.nonbanks' | translate}}</span>
  </h5>
  @if (!!ccrData?.nonBanksData) {   
  <itfg-ecr-data-section 
    [sectionData]="ccrData.nonBanksData"
    [columnsActive]="columnsActiveEcr"
    [columnsRelatedEcr]="columnsRelatedEcr"
    [columnsActiveMultiproducts]="columnsActiveMultiproducts"
    [columnsOverdue]="columnsOverdueEcr"
    [columnsDelinquencyHistoryEcr]="columnsDelinquencyHistoryEcr"
    [columnsLegacyDelinquencyHistoryEcr]="columnsLegacyDelinquencyHistoryEcr"
    [columnsInquiryEcr]="columnsInquiryEcr">
  </itfg-ecr-data-section>
  } @else {
    <mat-card>
      <mat-card-content>
        <span flex
              layout="row"
              class="no-data-label"
              [translate]="'global.noData'">
          No Data
        </span>
      </mat-card-content>
    </mat-card>
  }

}
